import "./seriesNoEpisodes.css"
import { Tv, Users, CircleDollarSign, Clapperboard, Grid, List } from "lucide-react";
import {useState, useEffect} from "react";
import axios from "axios";

const SeriesNoEpisodes = () => {

    const [totalSeries, setTotalSeries] = useState(0);
    const [totalUsers, setTotalUsers] = useState(0);
    const [totalEarnings, setTotalEarnings] = useState(0);
    const [totalViews, setTotalViews] = useState(0);

    const [animeData, setAnimeData] = useState([]);

    const [view, setView] = useState("list");
    const [filter, setFilter] = useState("Sve");

    const filteredAnime = animeData.filter((anime) => filter === "Sve" || anime.status === filter);

    const calculatePriority = (anime) => {
        let score = 0;

        // 1. MAL Rating - Exponential boost after 7.5
        if (anime.MAL_ocena) {
            const rating = parseFloat(anime.MAL_ocena);
            const normalized = Math.pow(rating / 10, 2) * 70; // nonlinear
            score += Math.min(normalized, 70);
        }

        // 2. Air date - strong boost for newer shows (within last 5 years)
        if (anime.date_sorted) {
            const year = new Date(anime.date_sorted).getFullYear();
            const now = new Date().getFullYear();
            const diff = now - year;

            if (diff <= 1) score += 20;
            else if (diff <= 3) score += 17;
            else if (diff <= 5) score += 13;
            else if (diff <= 10) score += 8;
            else score += 3;
        }

        // 3. Episode count - reward shorter, punish long series
        if (anime.ep) {
            const ep = anime.ep;
            if (ep <= 12) score += 10;
            else if (ep <= 50) score += 5;
            else if (ep <= 100) score += 0;
            else if (ep <= 200) score -= 5;
            else score -= 10;
        }

        // 4. Views (optional)
        if (anime.totalViews !== undefined) {
            const viewsScore = Math.min(anime.totalViews, 500000) / 500000 * 10;
            score += viewsScore;
        }

        // Clamp to 0–100 range
        return Math.max(0, Math.round(score));
    };



    useEffect(() => {
        const fetchData = async () => {
            try {
                const usersResponse = await axios.get('https://balkanflix-server.up.railway.app/api/auth/countAllUsers');
                setTotalUsers(usersResponse.data.totalUsers);
                setTotalSeries(usersResponse.data.totalSeries);
            }catch (e) {
                console.log(e)
            }
        }

        const fetchViews = async () => {
            try {
                const {data} = await axios.get('https://filemoonapi.com/api/account/stats?key=46529qdxsb1y65ki1juu9&last=30');
                setTotalViews(data.result.slice(30).reduce((acc, item) => acc + item.views, 0));
            }catch (e) {
                console.log(e)
            }
        }

        const fetchRevenue = async () => {
            try {
                const endDate = new Date();
                const startDate = new Date();
                startDate.setDate(endDate.getDate() - 90);

                const formatDate = (date) => {
                    const year = date.getFullYear();
                    const month = (date.getMonth() + 1).toString().padStart(2, '0');
                    const day = date.getDate().toString().padStart(2, '0');
                    return `${year}-${month}-${day}`;
                };

                const formattedStartDate = formatDate(startDate);
                const formattedEndDate = formatDate(endDate);

                const {data} = await axios.get(`https://balkanflix-server.up.railway.app/api/auth/publisher-stats/1114902?start_date=${formattedStartDate}&end_date=${formattedEndDate}&group_by=country&sort_by=-earnings`);
                const totalRevenue = data.map(item => parseFloat(item.earnings)).reduce((total, value) => total + value, 0);
                setTotalEarnings(totalRevenue.toFixed(2));
            }catch (e) {
                console.log(e)
            }
        }

        const fetchSeries = async () => {
            try {
                const {data} = await axios.get("https://balkanflix-server.up.railway.app/api/content/seriesWithoutEpisodes");
                const processedData = data.map(anime => ({
                    ...anime,
                    priority: calculatePriority(anime),
                    years: anime.date_sorted.split("-")[0]
                }))
                setAnimeData(processedData);
                console.log(processedData);
            }catch (e) {
                console.log(e)
            }
        }

        fetchData();
        fetchViews();
        fetchRevenue();
        fetchSeries();
    }, []);

    return (
        <div className="sn-dashboard">
            <div className="sn-stats">
                <div className="sn-stat-card"><Tv /> <div><h3>Ukupno Anime Serija</h3><h2>{totalSeries}</h2></div></div>
                <div className="sn-stat-card"><Clapperboard /> <div><h3>Ukupno Pregleda</h3><h2>{totalViews}</h2></div></div>
                <div className="sn-stat-card"><Users /> <div><h3>Ukupno Korisnika</h3><h2>{totalUsers}</h2></div></div>
                <div className="sn-stat-card"><CircleDollarSign /> <div><h3>Ukupno Prihoda</h3><h2>{totalEarnings}$</h2></div></div>
            </div>

            <div className="sn-filters-container">
                <div>
                    <h2>Anime Serije bez prevoda</h2>
                    <h5 className="sn-subtitle">Upravljajte našom anime bibliotekom</h5>
                </div>
                <div className="sn-filters">
                    <button onClick={() => setFilter("Sve")} className={filter === "Sve" ? "sn-active" : ""}>Sve</button>
                    <button onClick={() => setFilter("Emituje se")} className={filter === "Emituje se" ? "sn-active" : ""}>Emituje se</button>
                    <button onClick={() => setFilter("Završeno")} className={filter === "Završeno" ? "sn-active" : ""}>Završeno</button>
                    <button onClick={() => setView("grid")} className={view === "grid" ? "sn-active" : ""}><Grid /></button>
                    <button onClick={() => setView("list")} className={view === "list" ? "sn-active" : ""}><List /></button>
                </div>
            </div>

            <div className={view === "grid" ? "sn-anime-grid" : "sn-anime-list"}>
                {filteredAnime.map((anime, index) => (
                    <div className="sn-anime-card" key={index}>
                        <div className="sn-anime-info">
                            <h3>{anime.title}</h3>
                            <p>⭐ {anime.MAL_ocena} ({anime.ep} epizoda)</p>
                            <div className="sn-genres">
                                {Array.isArray(anime.genre) && anime.genre.map((genre, index) => (
                                    <span className="sn-tag" key={index}>{genre}</span>
                                ))}
                            </div>
                            <span className="sn-tag">{anime.years}</span>
                            <span className={`sn-status sn-${anime.status.toLowerCase()}`}>{anime.status}</span>
                            <div className="sn-engagement-bar">
                                <div style={{ width: `${anime.priority}%` }}></div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SeriesNoEpisodes;